import React, { useEffect, useState, useRef, useContext } from "react";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import socket from "../Components/socket";
import "../css/landing.css";
import Rightcontainer from "../Components/Rightcontainer";
import Downloadbutton from "../Components/Downloadbutton";
import DownloadPopup from "../Components/DownloadPopup";
import io from "../Components/socket";
import Header from "../Components/Header";
import { Token } from "@mui/icons-material";
import SliderCode from "../Components/SliderCode";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";

export default function Landing({ userAllData }) {
  const [open, setOpen] = useState(false);
  const [showDownloadPopup, setShowDownloadPopup] = useState(true);
  // const [userAllData, setUserAllData] = useState()

  // language
  const translations = {
    hi: { Tournaments: "प्रतियोगिता" },
    en: { Tournaments: "Tournaments" },
  };

  const MyData = localStorage.getItem("udata");
  const meedata = JSON.parse(MyData);
  const { language } = useContext(LanguageContext);

  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);
  // console.log(addCaseSetting);

  // const role = async () => {
  //   const access_token = localStorage.getItem('token')
  //   io.emit('getprofile', access_token)
  //   io.on('setProfile', data => {
  //     // setUserAllData(data)
  //   })
  // }

  useEffect(() => {
    // role()
  }, []);

  // change theme
  const theme = localStorage.getItem("theme");

  const styles = {
    backgroundColor: theme === "light" ? "#fff" : "#ff",
    color: theme === "light" ? "black" : "#fff",
    // padding: '20px',
    // margin: '20px',
  };

  const styles3 = {
    backgroundColor: theme === "light" ? "#26355D" : "#27241b",
    color: theme === "light" ? "#fff" : "#fff",
  };
  const history = useHistory();

  const handleClick = (e) => {
    if (meedata?.verified === "unverified") {
      e.preventDefault(); // page pe jaane se roke
      Swal.fire({
        icon: "warning",
        html: `
    <h4 style="color:white; margin-bottom:10px;">
      Please complete KYC
    </h4>
    <p style="color:white;">
      You need to complete your KYC before proceeding.
    </p>
  `,
        background: "linear-gradient(135deg, #1e3a8a, #0f172a)",
        confirmButtonText: "Verify Now",
        confirmButtonColor: "#f59e0b",
      }).then((result) => {
        if (result.isConfirmed) {
          history.push("/Profile"); // ✅ redirect
        }
      });

      return;
    }
    history.push("/");
  };

  return (
    <>
      {showDownloadPopup && (
        <DownloadPopup onClose={() => setShowDownloadPopup(false)} />
      )}
      <div
        className="leftContainer mb_space pt-4"
        style={{ height: "119% !important" }}
      >
        <div className="Orher_page_main_section" >
          <div className="main-area" >
            {JSON.parse(localStorage.getItem("sitSetting"))?.site_message !=
              null &&
              JSON.parse(localStorage.getItem("sitSetting"))?.site_message !=
                "" && (
                <div className="gameCard" >
                  <div className="alrt_msg_div">
                    <h5 className="">
                      {
                        JSON.parse(localStorage.getItem("sitSetting"))
                          ?.site_message
                      }
                    </h5>
                  </div>
                </div>
              )}
            {/* <SliderCode /> */}

            {/* <h6 className="text-danger blink" style={{ fontSize: "16px" }}> Live</h6> */}
            {/* <div>

              <Link
                className='gameCard-container'
                to={addCaseSetting?.isLudokingClassic ? '/Homepage/ludoClassicManual' : '#'}
              >
                <img className='w-100 mb-2 curverd-class' src='/mainimage/barimage.jpg' />
              </Link>

            </div> */}

            <section className="games-section" >
              {/* <h5 className='h5-bold'>PLAY GAMES WITH mannatludo</h5> */}

              <div className="games-section-headline mt-0 pb-2 mb-sm-4 mb-3">
                <div className="games-window ">
                  <>
                    {/* LUDO CLASSIC MANUAL */}

                    <Link
                      className="gameCard-container"
                      to={
                        addCaseSetting?.isLudokingClassic
                          ? "/Homepage/ludoClassicManual"
                          : "#"
                      }
                      //  a
                    >
                      <div className={`gameCard`} style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.2)' }}>
                         <span className="d-none blink  d-block text-right bg_green game_live_status_position" style={{ background: 'linear-gradient(45deg, #ff6b6b, #4ecdc4)', color: '#fff', padding: '5px 10px', borderRadius: '0 20px 0 20px' }}>
                          {addCaseSetting?.isLudokingClassic
                            ? " ◉ LIVE"
                            : " ◉ Comming Soon"}
                        </span>
                        
                        <picture className="gameCard-image">
                          <img
                            width="100%"
                            src="./mainimage/ima1ge.jpg"
                            alt="Ludo Classic"
                          />
                        </picture>
                        {/* <div class="card-footer d-flex align-items-center"><a href="javascript:void(0);" class="btn-yellow ml-auto">Play Now</a></div> */}
                      </div>
                    </Link>

                    {
                      <>
                        {/* mannatludo CLASSIC */}

                        {/* <Link
                          className='gameCard-container'
                          to={addCaseSetting?.mannatludoClassic ? '/Homepage/popular' : '#'}
                        >
                          <div className={`gameCard`}>
                            <span className='d-none blink  d-block text-right bg_green game_live_status_position'>

                              {addCaseSetting?.isLudokingClassic ? ' ◉ Comming Soon' : ' ◉ Comming Soon'}
                            </span>
                            <picture className='gameCard-image'>
                              <img
                                width='100%'
                                src='./mainimage/ludopopular.jpg'
                                alt='Ludo Classic'
                              />
                            </picture>
                          </div>
                        </Link> */}

                        {/* mannatludoLUDO */}

                        {/* <Link
                            className='gameCard-container'
                            to={addCaseSetting?.mannatludoLudo ? '/Homepage/ludoulta1' : '#'}
                          >
                            <div className={`gameCard`}>
                              <span className='d-none blink  d-block text-right text-white bg_green game_live_status_position'>

                                {addCaseSetting?.mannatludoLudo ? ' ◉ LIVE' : '  ◉ COMING SOON'}
                              </span>
                              <picture className='gameCard-image'>
                                <img
                                  width='100%'
                                  src='./mainimage/ludosnake.jpg'
                                  alt='Ludo Classic'
                                />
                              </picture>
                            </div>
                          </Link> */}

                        {/* mannatludoONE */}
                        <a
                          href={
                            JSON.parse(localStorage.getItem("sitSetting")) ==
                            "undefined"
                              ? ""
                              : JSON.parse(localStorage.getItem("sitSetting"))
                                  ?.whatsappSupport
                          }
                          target="_blank"
                          className="gameCard-container"
                        >
                          <div className={`gameCard`} style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.2)' }}>
                            <span className="d-none blink  d-block text-right text-danger bg_green game_live_status_position" style={{ background: 'linear-gradient(45deg, #ff6b6b, #4ecdc4)', color: '#fff', padding: '5px 10px', borderRadius: '0 20px 0 20px' }}>
                              {" ◉ LIVE"}
                            </span>
                            <picture className="gameCard-image">
                              <img
                                width="100%"
                                src="./mainimage/ludosupport.png"
                                alt="Ludo Classic"
                              />
                            </picture>
                          </div>
                        </a>
                      </>
                    }
                  </>
                </div>
                <div></div>
              </div>
              
            </section>

            {/* 
            <div className='downloadButton'>
              <Downloadbutton />
            </div> */}
          </div>
        </div>
      </div>
      <div className="support_samll_card_btn_type whatsap_btn">
        {JSON.parse(localStorage.getItem("sitSetting")) == "undefined" ? (
          ""
        ) : JSON.parse(localStorage.getItem("sitSetting"))?.whatsappSupport ? (
          <>
            <a
              href={
                JSON.parse(localStorage.getItem("sitSetting")) == "undefined"
                  ? ""
                  : JSON.parse(localStorage.getItem("sitSetting"))
                      ?.whatsappSupport
              }
              target="_blank"
            >
              {/* <img
                width="40px"
                src={process.env.PUBLIC_URL + "/images/whatsapp.png"}
                alt=""
              /> */}
            </a>
          </>
        ) : (
          ""
        )}
      </div>
      <div
        className="support_samll_card_btn_type whatsap_btn"
        style={{ marginBottom: "65px" }}
      >
        {JSON.parse(localStorage.getItem("sitSetting")) == "undefined" ? (
          ""
        ) : JSON.parse(localStorage.getItem("sitSetting"))?.CompanyMobile ? (
          <>
            {/* <a
              href={
                `tel:${JSON.parse(localStorage.getItem("sitSetting")) ==
                  "undefined"
                  ? ""
                  : JSON.parse(localStorage.getItem("sitSetting"))
                    ?.CompanyMobile}`
              }
              target="_blank"
            >
              <img
                width="40px"
                src={process.env.PUBLIC_URL + "/images/phone.png"}
                alt=""
              />
            </a> */}
          </>
        ) : (
          ""
        )}
      </div>

      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </>
  );
}
